export default __webpack_public_path__ + "static/media/README.c91ffdf3.md";